import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Building2 } from 'lucide-react';
import { useSubscription, Subscription } from '@/contexts/SubscriptionContext';

/**
 * Modal for selecting a subscription/organisation in standalone (dev) mode.
 * Displayed when a user has access to multiple subscriptions.
 */
export default function SubscriptionPickerModal() {
  const {
    subscriptions,
    showSubscriptionPicker,
    setShowSubscriptionPicker,
    selectSubscription,
  } = useSubscription();

  const handleSelect = (subscription: Subscription) => {
    selectSubscription(subscription.subscriptionId);
    setShowSubscriptionPicker(false);
  };

  return (
    <Dialog open={showSubscriptionPicker} onOpenChange={() => {}}>
      <DialogContent
        className="max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Select Organisation</DialogTitle>
          <DialogDescription>
            You have access to multiple organisations. Please select which one you want to work in.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 py-4 max-h-[400px] overflow-y-auto">
          {subscriptions.map((subscription) => (
            <Button
              key={subscription.subscriptionId}
              variant="outline"
              className="w-full justify-start h-auto py-3 px-4"
              onClick={() => handleSelect(subscription)}
            >
              <Building2 className="w-5 h-5 mr-3 flex-shrink-0 text-muted-foreground" />
              <div className="text-left">
                <div className="font-medium">
                  {subscription.organizationName || 'Unnamed Organisation'}
                </div>
                <div className="text-xs text-muted-foreground">
                  {subscription.subscriptionId}
                </div>
              </div>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
